//extracted by mini-css-extract-plugin
export default {"select":"CustomSelect_select__S16vV","noLabel":"CustomSelect_noLabel__j0lTz"};;